import React from 'react';
import YouTube from 'react-youtube';

const VideoPlayer = ({ videoId, size = 'large' }) => {
  // Define video sizes
  const sizes = {
    small: { width: 320, height: 180 }, // Adjusted for a more mobile-friendly size
    large: { width: Math.min(window.innerWidth * 0.9, 640), height: (Math.min(window.innerWidth * 0.9, 640) * 9) / 16 },
  };

  // Options for the YouTube player
  const opts = {
    height: sizes[size].height,
    width: sizes[size].width,
    playerVars: {
      autoplay: 0,         // Disable autoplay
      controls: 1,         // Show video controls
      modestbranding: 1,   // Minimal YouTube branding
      rel: 0,              // Show related videos only from the same channel
    },
  };

  return videoId ? (
    <div className="w-full flex justify-center">
      <YouTube videoId={videoId} opts={opts} />
    </div>
  ) : null;
};

export default VideoPlayer;
